export function formatCycleLabel(value) {
  if (value === null || value === undefined) return "N/A";

  const raw = String(value).trim();
  if (!raw) return "N/A";

  const normalized = raw.toUpperCase().replace(/\s+/g, " ");

  // If caller already passes a label, normalize it.
  if (normalized === "MONTHLY") return "MONTHLY";
  if (normalized === "QUARTERLY") return "QUARTERLY";
  if (["HALF YEARLY", "HALF-YEARLY", "HALFYEARLY"].includes(normalized)) return "HALF YEARLY";
  if (["ANNUALLY", "ANNUAL", "YEARLY"].includes(normalized)) return "ANNUALLY";

  // Map month counts (e.g. "1 Month", "3 Months", 6, "12") to labels.
  const monthMatch = normalized.match(/(\d+)\s*(MONTH|MONTHS|M)\b/);
  const months = monthMatch
    ? Number(monthMatch[1])
    : normalized.match(/^\d+$/)
    ? Number(normalized)
    : null;

  if (!Number.isFinite(months) || months <= 0) return "N/A";

  switch (months) {
    case 1:
      return "MONTHLY";
    case 3:
      return "QUARTERLY";
    case 6:
      return "HALF YEARLY";
    case 12:
      return "ANNUALLY";
    default:
      return raw;
  }
}
